<template>
  <div class="extension">
    <TabsHead active-tab="extension"> </TabsHead>
    <Card>
      <Tabs v-model="name">
        <TabPane :label="$t('plugins.plugins')">
          <Plugins v-if="name === 0" class="tab-body"></Plugins>
        </TabPane>
        <TabPane :label="$t('services.services')">
          <Services v-if="name === 1" class="tab-body"></Services>
        </TabPane>
        <TabPane :label="$t('services.functions')">
          <FunctionList v-if="name === 2" class="tab-body"></FunctionList>
        </TabPane>
        <TabPane :label="$t('plugins.portable')">
          <Portables v-if="name === 3" class="tab-body"></Portables>
        </TabPane>
      </Tabs>
    </Card>
  </div>
</template>

<script>
import TabsHead from '@/components/TabsHead'
import Plugins from './plugins/Plugins'
import Services from './services/Services'
import FunctionList from './services/FunctionList'
import Portables from './plugins/Portables'

export default {
  name: 'Extension',
  data() {
    return {
      name: 0,
    }
  },
  components: {
    TabsHead,
    Plugins,
    Services,
    FunctionList,
    Portables,
  },
}
</script>

<style lang="scss">
.extension {
  .ivu-card-body {
    padding: 0;
  }
  .tab-body {
    padding: 20px;
  }
}
</style>
